"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = void 0;
var Region;
(function (Region) {
    Region["NA"] = "NA";
    Region["EU"] = "EU";
    Region["APAC"] = "APAC";
})(Region = exports.Region || (exports.Region = {}));
//# sourceMappingURL=Region.js.map